import { createResource } from 'solid-js';
import { getCurrentUserRaw, UserContext } from './auth';

export const UserProvider = (props) => {
  const [user] = createResource(getCurrentUserRaw);

  return <UserContext.Provider value={user}>{props.children}</UserContext.Provider>;
}
